import type { FalhaHttp } from './falha-http'

export type MetodoHttp = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

export type HeadersHttp = Readonly<Record<string, string>>

export type ParametrosHttp = Readonly<Record<string, unknown>>

export type DestinoRetry = 'principal' | 'fallback'

export type TentativaRetry = Readonly<{
  atrasoMs: number
  destino: DestinoRetry
}>

export type ContextoRetry = Readonly<{
  numeroTentativa: number
  totalTentativas: number
}>

export type EstrategiaRetry = Readonly<{
  tentativas: readonly TentativaRetry[]
  deveRepetir?: (falha: FalhaHttp, contexto: ContextoRetry) => boolean
}>

export const ESTRATEGIA_RETRY_PADRAO: EstrategiaRetry = Object.freeze({
  tentativas: Object.freeze([
    Object.freeze({ atrasoMs: 1_000, destino: 'fallback' }),
    Object.freeze({ atrasoMs: 2_000, destino: 'principal' }),
    Object.freeze({ atrasoMs: 4_000, destino: 'fallback' }),
  ]),
})

export type OpcoesHttp = Readonly<{
  headers?: HeadersHttp
  parametros?: ParametrosHttp
  timeoutMs?: number
  signal?: AbortSignal
  retry?: EstrategiaRetry
}>

export type RespostaHttp<T> = Readonly<{
  data: T
  status: number
  headers: HeadersHttp
  requestId?: string
}>

export interface ClienteHttp {
  get<T>(rota: string, opcoes?: OpcoesHttp): Promise<RespostaHttp<T>>

  post<TResposta>(
    rota: string,
    corpo?: unknown,
    opcoes?: OpcoesHttp,
  ): Promise<RespostaHttp<TResposta>>

  put<TResposta>(
    rota: string,
    corpo?: unknown,
    opcoes?: OpcoesHttp,
  ): Promise<RespostaHttp<TResposta>>

  patch<TResposta>(
    rota: string,
    corpo?: unknown,
    opcoes?: OpcoesHttp,
  ): Promise<RespostaHttp<TResposta>>

  delete<T>(rota: string, opcoes?: OpcoesHttp): Promise<RespostaHttp<T>>
}
